import {required} from 'vuelidate/lib/validators'
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            form: {
                title: '',
                description: '',
                np_title: 'TurboSMS',
                np_module: 'Turbosms',
                np_description: this.$t('plugins.np_desc'),
                np_status: 1,
                turbo_sms_sender: '',
                turbo_sms_api_key: '',
                turbo_secret_key: '',
            },
            list: {
            },
            npAreasList:[],
            npAreasListId:null,
            npCityList:[],
            npCityListId:null,
            npCityWarehouses:[],
            npCityWarehousesId:null,
            contragent: [
                {
                    id:'none',
                    title: this.$t('pluginBinotel.none')
                }
            ],
            address:[
                {
                    id:'none',
                    title: this.$t('pluginBinotel.none')
                }
            ],
            dbCounterpartiesList: [],
        }
    },

    validations: {
        form: {
            np_title: {
                required
            }
        }
    },
    computed: {
        ...mapGetters({
            options:'config/options',
            npWarehouses: 'plugins/npWarehouses',
            warehouse: 'warehouse/warehouse',
            npAreas: 'plugins/npAreas',
            npCity: 'plugins/npCity',
            counterpartySender: 'plugins/counterpartySender',
            counterpartyAddress: 'plugins/counterpartyAddress',
            npCounterparties: 'npAutomation/npCounterparties',
        }),
    },
    watch:{
        npAreas(e){
            this.npAreasList = [];
            this.npCityList = [];
            this.list.np_area = null;
            this.list.np_city = null;
            this.npCityWarehouses = [];
            this.list.np_warehouse = null;
            let key;
            for(key in e.models){
                this.npAreasList.push(
                    {
                        id:key,
                        title:e.models[key],
                    }
                )
            }
            this.checkOption(this.options);
        },
        npCity(e){
            this.npCityList = [];
            this.list.np_city = null;
            this.npCityWarehouses = [];
            this.list.np_warehouse = null;
            let key;
            for(key in e.models){
                this.npCityList.push(
                    {
                        id:key,
                        title:e.models[key],
                    }
                )
            }
        },
        npWarehouses(e){
            this.npCityWarehouses = [];
            this.list.np_warehouse = null;
            let key;
            for(key in e.models){
                this.npCityWarehouses.push(
                    {
                        id:key,
                        title:e.models[key],
                    }
                )
            }
        },
        options(e){
            this.checkOption(e);
        },
        counterpartySender(e){
            this.contragent = [];
            let key;
            for(key in e.models){
                this.contragent.push({
                    id: key,
                    title: e.models[key],
                })
            }
            this.getCounterpartyAddressWithApiKey(this.form.np_counterparty_sender);
        },
        counterpartyAddress(e){
            this. address = [];
            let key;
            for(key in e.models){
                this.address.push({
                    id: key,
                    title: e.models[key],
                })
            }
        },
        npCounterparties(data) {
            this.dbCounterpartiesList = [];
            if (data && Array.isArray(data)) {
                this.dbCounterpartiesList = data.map(item => ({
                    id: item.ref,
                    ref: item.ref,
                    name: item.name,
                    is_default: item.is_default,
                    _raw: item,
                }));
            }
        },
    },
    created() {
        this.getNpAreas();
        this.checkOption(this.option);
        // Load counterparties from DB first
        this.getNpCounterparties().then(() => {
            this.getCounterpartySenderWithApiKey();
        }).catch(() => {
            // Fallback if DB counterparties fail to load
            this.getCounterpartySenderWithApiKey();
        });
    },
    methods: {
        checkOption(res){
            if(res){
                this.form = res.models;
                this.selectedArea();
                this.selectedCity()
            }else{
                this.form = this.list
            }
        },
        selectedArea(){
            this.getNpCity({'area_id': this.form.np_area})
        },
        selectedCity(){
            this.getNpWarehouses({'city_id': this.form.np_city})
        },
        closePopup() {
            this.$emit('closePopup')
        },
        sendConfirm() {
            if(this.warehouse){
                this.$emit('changeOptions', this.form)
            }else{
                this.$emit('sendOptions', this.form)
            }
        },
        getSenderAddress(){
            this.getCounterpartyAddressWithApiKey(this.form.np_counterparty_sender);
        },
        getCounterpartySenderWithApiKey() {
            // Check if we have default counterparty in DB
            const defaultCounterparty = this.dbCounterpartiesList.find(cp => cp.is_default === true);
            if (defaultCounterparty && defaultCounterparty._raw?.id) {
                // Use default counterparty's API key via db_counterparty_id
                this.getCounterpartySender({ db_counterparty_id: defaultCounterparty._raw.id });
            } else {
                // Require default counterparty - no fallback to global API key
                const errorMsg = this.$t('toasts.err_default_counterparty');
                if (this.$toasted) {
                    this.$toasted.error(errorMsg, { duration: 5000 });
                }
                console.error('No default counterparty found in database');
                throw new Error(errorMsg);
            }
        },
        getCounterpartyAddressWithApiKey(counterpartyId) {
            if (!counterpartyId) {
                return;
            }
            // Check if counterparty exists in DB
            const dbCounterparty = this.dbCounterpartiesList.find(cp => 
                cp.id === counterpartyId || cp.ref === counterpartyId
            );
            
            if (dbCounterparty && dbCounterparty._raw?.id) {
                // Use counterparty-specific API key via db_counterparty_id
                this.getCounterpartyAddress({
                    counterparty_id: counterpartyId,
                    db_counterparty_id: dbCounterparty._raw.id
                });
            } else {
                // Require database counterparty - no fallback to global API key
                const errorMsg = this.$t('popupNpTtn.err_select_or_add');
                if (this.$toasted) {
                    this.$toasted.error(errorMsg, { duration: 5000 });
                }
                console.error('Counterparty not found in database:', counterpartyId);
                throw new Error(errorMsg);
            }
        },
        ...mapActions({
            getNpAreas:'plugins/getNpAreas',
            getNpCity:'plugins/getNpCity',
            getNpWarehouses:'plugins/getNpWarehouses',
            getCounterpartySender:'plugins/getCounterpartySender',
            getCounterpartyAddress:'plugins/getCounterpartyAddress',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
        }),
        ...mapMutations({
            changeShowWarehouse: 'warehouse/changeShowWarehouse'
        })
    },
    destroyed() {
        this.changeShowWarehouse(null);
    }
}